export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FacultyDirectory.vue?vue&type=template&id=20d386c6"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FacultyDirectory.vue?vue&type=template&id=20d386c6
// module id = 393
// module chunks = 0